import ActionType from './actionType';

export const updateId = (id) => ({
  type: ActionType.UPDATE_NA_ID,
  payload: {
    id,
  },
});

export const updateCurrentSituation = (leaseExpirationYear, size) => ({
  type: ActionType.UPDATE_CURRENT_SITUATION,
  payload: {
    leaseExpirationYear,
    size,
  },
});

export const updateParams = (headcount, inOffice, fullyRemote, hybrid, daysInOffice) => ({
  type: ActionType.UPDATE_PARAMS,
  payload: { headcount, inOffice, fullyRemote, hybrid, daysInOffice },
});

export const updateTotalHeadcount = (headcount) => ({
  type: ActionType.UPDATE_TOTAL_HEADCOUNT,
  payload: { headcount },
});

export const updateRatios = (sharedSeatsRatio) => ({
  type: ActionType.UPDATE_RATIOS,
  payload: { sharedSeatsRatio },
});

export const updateStartingYear = (startingYear) => ({
  type: ActionType.UPDATE_STARTINGYEAR,
  payload: { startingYear },
});

export const updateLeaseTermInYears = (leaseTermInYears) => ({
  type: ActionType.UPDATE_LEASETERMINYEARS,
  payload: {
    leaseTermInYears,
  },
});

export const updateDefaultGrowth = (defaultGrowth) => ({
  type: ActionType.UPDATE_DEFAULTGROWTH,
  payload: {
    defaultGrowth,
  },
});

export const updateGrowthChange = (change, index) => ({
  type: ActionType.UPDATE_GROWTH_CHANGE,
  payload: {
    change,
    index,
  },
});

export const updateGrowthHeadcount = (headcount, index) => ({
  type: ActionType.UPDATE_GROWTH_HEADCOUNT,
  payload: {
    headcount,
    index,
  },
});

export const updateWorkplaceStyleSelected = (workplacestyleSelected) => ({
  type: ActionType.UPDATE_WORKPLACE_STYLE_SELECTED,
  payload: {
    workplacestyleSelected,
  },
});

export const updateSpaceType = (spaceType) => ({
  type: ActionType.UPDATE_SPACES,
  payload: {
    spaceType,
  },
});

export const updateSpaceSettings = (settings) => ({
  type: ActionType.UPDATE_SPACE_SETTINGS,
  payload: {
    ...settings,
  },
});

export const updateCustomSpace = (customSpace) => ({
  type: ActionType.UPDATE_CUSTOM_SPACES,
  payload: {
    customSpace,
  },
});

export const updateLastStep = (lastStep) => ({
  type: ActionType.UPDATE_LAST_STEP,
  payload: {
    lastStep,
  },
});

export const updateScorecardReached = (scoreCardReached) => ({
  type: ActionType.UPDATE_SCORECARD_REACHED,
  payload: {
    scoreCardReached,
  },
});


export const removeCustomSpace = (customSpace) => ({
  type: ActionType.REMOVE_CUSTOM_SPACES,
  payload: {
    customSpace,
  },
});

export const setNA = (na) => ({
  type: ActionType.SET_NA,
  payload: {
    na,
  },
});

export const resetNA = () => ({
  type: ActionType.RESET_NA,
  payload: {},
});

export const addSharedUser = (shareduser) => ({
  type: ActionType.ADD_SHARED_USER,
  payload: {
    shareduser,
  },
});

export const removeSharedUser = (shareduser) => ({
  type: ActionType.REMOVE_SHARED_USER,
  payload: {
    shareduser,
  },
});

export const setAnyoneCanAccess = (anyonecanaccess) => ({
  type: ActionType.SET_ANYONE_CAN_ACCESS,
  payload: {
    anyonecanaccess,
  },
});
